module.exports = __webpack_public_path__ + "img/beijing@2x.5878e28b.png";